module.exports = __webpack_public_path__ + "img/1.14216b59.jpg";